import { listLayananSnapcleanOwner } from "./state"

const mutations = {
	setListLayananSnapcleanOwner: (state, res) => {
		state.listLayananSnapcleanOwner = res
	},

	resetListLayananSnapcleanOwner: (state) => {
		state.listLayananSnapcleanOwner = listLayananSnapcleanOwner()
	}
}

export default mutations